<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="480">
	    <el-table-column fixed prop="bt" label="标题" width="400" />
	    <el-table-column fixed prop="ms" label="描述" width="300" />
	    <el-table-column prop="dz" label="地址" width="300" />
		<el-table-column prop="createdate" label="创建日期" width="200" />
	    <el-table-column fixed="right" label="操作" width="*" class-name="operate-style-sss">
	      <template #default="scope">
	        <el-button link type="primary" size="small" @click="handleDtClick(scope.row)">详情</el-button>
			<el-button link type="primary" size="small" @click="deleteData(scope.row)">删除</el-button>
			<el-button link type="primary" size="small" @click="openCarousel(scope.row)">轮播图管理</el-button>
	      </template>
	    </el-table-column>
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
	<el-dialog
		@close="closeDialog"
	    v-model="dialogVisible"
	    title="轮播图管理"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<Carousel />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDialog">关闭</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import Carousel from './carousel.vue';
	import { useMemberStore } from '../../../stores';
	import { ElMessage } from 'element-plus'
	import { useRoute, useRouter } from 'vue-router'
	const router = useRouter();
	const userStore = useMemberStore();
	const headers = ref({
		'Authorization': `${userStore.profile?.token}`,
	})
	const openCarousel= (e) =>{
		billid.value = e.id;
		dialogVisible.value = true;
	}
	const dialogVisible = ref(false)
	const closeDialog = () =>{
		dialogVisible.value = false;
	}
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const key = ref('');
	const tableData = ref([]);
	const billid = ref('');
	provide('billid', billid);
	onMounted(async()=>{
		const response = await axios.post('/restaurant/info/queryInfoList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	})
	const handleAvatarSuccess= (
	  response,
	  uploadFile
	) => {
	  if(response.status===0){
		response.imgUrl.replace(rootPath,baseURL);
	  }
	}
	
	const beforeAvatarUpload = (rawFile) => {
	  if (rawFile.type !== 'image/jpg'&&rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
	    ElMessage.error('Avatar picture must be JPG/PNG format!')
	    return false
	  } else if (rawFile.size / 1024 / 1024 > 12) {
	    ElMessage.error('Avatar picture size can not exceed 12MB!')
	    return false
	  }
	  return true
	}
	const fetchOrders = async () => {
		const response = await axios.post('/restaurant/info/queryInfoList', {
		  key:'bt',
		  value:key.value,
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}else{
			tableData.value = [];
			total.value = 0;
		}
	};
	const handleDtClick = (e)=>{
		billid.value = e.id;
		router.push({path:'/medical/restaurant-info',query:{billid:billid.value}}); // 退出后跳转到登录页面
	}
	const deleteData=async(e)=>{
		const response = await axios.post('/spa/info/delete', {
		  billid:e.id,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '删除成功!',
				type: 'success',
			})
			fetchOrders()
		}
		
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
</style>